
const ACTIONS = {
    CALL_API: 'call-api',
    SUCCESS: 'success',
    ERROR: 'error',

    SELECT_UPDATE_CHOICES: 'select-update-choices',
    SET_INITIAL_DATA: 'set-data',
    SELECT_CHANGE: 'select-change',
    SELECT_SET_ERRORS: 'select-set-errors',
    SELECT_REMOVE_ERRORS: 'select-remove-errors',
};

const selectInputDataReducer = (state, action) => {
    //console.log("select input dispatch triggered", state, action);

    switch (action.type) {
        case ACTIONS.SET_INITIAL_DATA: {
            return {
                ...state,
                options: action.options,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                }
            };
        }

        case ACTIONS.SELECT_UPDATE_CHOICES: {
            //console.log("state");
            //console.log(state);

            return {
                ...state,
                options: action.options
            };
        }

        case ACTIONS.SELECT_CHANGE: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);
            

            return {
                ...state,
                prevValue: state.value,
                value: action.value,
                options: 
                    state.options.map((option) => {
                        //console.log(option.value + " " + action.value);
                        if (option.value == action.value) {
                            //console.log("change");
                            option.isSelected = true;
                        }
                        else{
                            option.isSelected = false;
                        }

                        return option;
                        
                    }),
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: [],
                    isValid: false,
                    successMsgs: []
                },
                disabled: "disabled" in action ? action.disabled : state.disabled

            };
        }

        case ACTIONS.SELECT_SET_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: action.errors != null && action.errors.length > 0 ? true : false,
                    errors: action.errors
                }
            };
        }

        case ACTIONS.SELECT_REMOVE_ERRORS: {
            //console.log("state");
            //console.log(state);
            //console.log(action.name);

            return {
                ...state,
                validation:{
                    ...state.validation,
                    isInvalid: false,
                    errors: []
                }
            };
        }
    }
}



export {ACTIONS, selectInputDataReducer};